<template>
  <div class="com-empty">
    <img src="@/static/images/plan/empty-jzx.png" alt="" />
    <div class="empty-text" v-html="content" />
    <slot name="index-empty-tip" />
  </div>
</template>

<script>
export default {
  props: {
    content: {
      default: '暂无内容',
      type: String
    }
  }
}

</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
.com-empty {
  margin: 20px auto;
  text-align: center;
  img{
    display: block;
    width: 222px;
    height: auto;
    margin: 0 auto;
  }
  .empty-text {
    margin-top: 24px;
    color: @gray-3;
    font-size: 14px;
  }
}
</style>
